<template>
  <div class="justify-content-center mx-5">
    <div class="input-group">
      <button
        type="button"
        class="btn btn-primary m-2"
        data-bs-toggle="modal"
        data-bs-target="#inputModal"
        @click="addClick"
      >
        +
      </button>
      <div class="mx-3 pt-2">
        <h4>{{ ja_Job }}</h4>
      </div>
    </div>

    <!-- Job Summary Table -->
    <table class="table table-striped">
      <thead>
        <tr>
          <th>{{ ja_Employee }}</th>
          <th>{{ ja_Department }}</th>
          <th>{{ ja_Position }}</th>
          <th>{{ ja_TotalJobs }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="dat in jobs" :key="dat.jobId">
          <td data-bs-toggle="modal" data-bs-target="#employeeJobModal"
              @click="getTargetEmployeeName(dat.employeeName)">
            {{ dat.employeeName }}
          </td>
          <td data-bs-toggle="modal" data-bs-target="#employeeJobModal"
              @click="getTargetEmployeeName(dat.employeeName)">
            {{ dat.employeeDepartment }}
          </td>
          <td data-bs-toggle="modal" data-bs-target="#employeeJobModal"
              @click="getTargetEmployeeName(dat.employeeName)">
            {{ dat.employeePosition }}
          </td>
          <td data-bs-toggle="modal" data-bs-target="#employeeJobModal"
              @click="getTargetEmployeeName(dat.employeeName)">
            {{ dat.jobCount }}
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Charts -->
    <div class="charts-wrapper">
      <div class="chart-box">
        <canvas id="jobPieChart"></canvas>
      </div>

      <div class="chart-box">
        <canvas id="jobBarChart"></canvas>
      </div>

      <div class="chart-box">
        <canvas id="statusChart"></canvas>
      </div>

      <div class="chart-box">
        <canvas id="departmentChart"></canvas>
      </div>
    </div>

    <!-- Input Modal -->
    <input-modal-view
      :Title="modalTitle"
      :Id="JobId"
      @createData="createClick"
      @updateData="updateClick"
    >
      <template v-slot:modalBody>
        <div class="modal-body">

          <div class="input-group mb-3">
            <span class="input-group-text">{{ ja_Employee }}</span>
            <select class="form-control" v-model="EmployeeName">
              <option value="">-- Select Employee --</option>
              <option
                v-for="user in users"
                :key="user.id"
                :value="user.name"
              >
                {{ user.name }}
              </option>
            </select>
            <span class="input-group-text">{{ ja_Department }}</span>
            <input type="text" class="form-control" v-model="EmployeeDepartment" />

            <span class="input-group-text">{{ ja_Position }}</span>
            <input type="text" class="form-control" v-model="EmployeePosition" readonly />
          </div>

          <div class="input-group mb-3">
            <span class="input-group-text">{{ ja_DueDate }}</span>
            <input
              type="date"
              class="form-control"
              v-model="DueDate"
              :min="currentDate()"
            />
            <span class="input-group-text">{{ ja_Status }}</span>
            <select class="form-control" v-model="Status">
              <option value="">-- 選択してください --</option>
              <option value="新規">新規</option>
              <option value="進行中">進行中</option>
              <option value="遅延">遅延</option>
              <option value="期限超過">期限超過</option>
              <option value="その他">その他</option>
            </select>
          </div>

          <div class="input-group">
            <span class="input-group-text">{{ ja_Content }}</span>
            <input type="text" class="form-control" v-model="JobContent" />
          </div>

        </div>
      </template>
    </input-modal-view>

    <!-- Employee Detail Modal -->
    <div class="modal fade" id="employeeJobModal">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ EmployeeTargetName }} {{ ja_Job }}
            </h5>
            <button id="modal-closeDetail-btn"
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal">
            </button>
          </div>

          <div class="modal-body">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>{{ ja_Employee }}</th>
                  <th>{{ ja_Content }}</th>
                  <th>{{ ja_DueDate }}</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="dat in employeeJobs" :key="dat.jobId">
                  <td>{{ dat.employeeName }}</td>
                  <td>{{ dat.jobContent }}</td>
                  <td>{{ dat.dueDate }}</td>
                  <td>
                    <button class="btn btn-light me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#inputModal"
                            @click="editClick(dat)">
                      ✏️
                    </button>

                    <button class="btn btn-light"
                            @click="deleteJobClick(dat.jobId)">
                      🗑️
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ja from "../locales/ja.json";
import InputModalView from "./InputModalView.vue";
import Chart from "chart.js/auto";
import * as bootstrap from "bootstrap";
import ChartDataLabels from "chartjs-plugin-datalabels";

import {
  getTotalJobs,
  getEmployeeJobs,
  createJob,
  updateJob,
  deleteJob,
  getStatusSummary,
  getDepartmentSummary
} from "../api/jobs";

import { getUsers } from "../api/users";

export default {
  components: { InputModalView },

  data() {
    return {
      ja_Job: ja.Job,
      ja_Employee: ja.Employee,
      ja_Department: ja.Department,
      ja_Position: ja.Position,
      ja_Content: ja.Content,
      ja_DueDate: ja.DueDate,
      ja_Status: ja.Status,
      ja_TotalJobs: ja.TotalJobs,

      jobs: [],
      users:[],
      employeeJobs: [],

      JobId: 0,
      EmployeeName: "",
      EmployeeTargetName: "",
      EmployeeDepartment: "",
      EmployeePosition: "",
      JobContent: "",   // ✅ FIXED (was jobCount)
      DueDate: "",
      Status: "",

      modalTitle: ja.New,

      chartInstancePie: null,
      chartInstanceBar: null
    };
  },

  async mounted() {
    this.loadUsers();

    const user = localStorage.getItem("user-info");
    if (!user) {
      this.$router.push({ name: "login" });
      return;
    }

    await this.refreshData();

    // =========================
    // Department Chart
    // =========================
    const deptData = await getDepartmentSummary();

    const deptLabels = deptData.map(item => item.employeeDepartment);
    const deptValues = deptData.map(item => item.total);

    new Chart(document.getElementById("departmentChart"), {
      type: "pie",
      data: {
        labels: deptLabels,
        datasets: [{
          data: deptValues
        }]
      }
    });

    // =========================
    // Status Chart
    // =========================
    const statusData = await getStatusSummary();

    const statusLabels = statusData.map(item => item.status);
    const statusValues = statusData.map(item => item.total);

    new Chart(document.getElementById("statusChart"), {
      type: "bar",
      data: {
        labels: statusLabels,
        datasets: [{
          label: "Jobs by Status",
          data: statusValues
        }]
      }
    });
  },

  watch: {
    EmployeeName(newVal) {
      const selected = this.users.find(u => u.name === newVal);
      if (selected) {
        this.EmployeeDepartment = selected.department;
        this.EmployeePosition = selected.position;
      }
    },
    DueDate() {
      this.autoUpdateStatus();
    }
  },

  methods: {

    async loadUsers() {
      try {
        this.users = await getUsers();
      } catch (error) {
        alert("Load users failed: " + error);
      }
    },

    autoUpdateStatus() {
      if (!this.DueDate) return;

      if (this.Status === "その他") return;

      const today = new Date();
      const due = new Date(this.DueDate);

      today.setHours(0,0,0,0);
      due.setHours(0,0,0,0);

      if (today > due) {
        this.Status = "期限超過";
      } else if (today.getTime() === due.getTime()) {
        this.Status = "遅延";
      } else {
        this.Status = "進行中";
      }
    },

    currentDate() {
      const d = new Date();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${month}-${day}`;
    },

    addClick() {
      this.modalTitle = ja.New;
      this.JobId = 0;
      this.EmployeeName = "";
      this.EmployeeDepartment = "";
      this.EmployeePosition = "";   // ✅ ADD THIS
      this.JobContent = "";
      this.DueDate = this.currentDate();
      this.Status = ja.DefaultStatus;
    },

    async createClick() {
      try {
        await createJob({
          EmployeeName: this.EmployeeName,
          EmployeeDepartment: this.EmployeeDepartment,
          EmployeePosition: this.EmployeePosition, 
          JobContent: this.JobContent,   // ✅ FIXED
          DueDate: this.DueDate,
          Status: this.Status
        });

        document.getElementById("modal-close-btn").click();
        await this.refreshData();
      } catch (e) {
        alert("Create failed " + e);
      }
    },

    editClick(dat) {
      this.modalTitle = ja.Edit;
      this.JobId = dat.jobId;
      this.EmployeeName = dat.employeeName;
      this.EmployeeDepartment = dat.employeeDepartment;
      this.EmployeePosition = dat.employeePosition;
      this.JobContent = dat.jobContent;
      this.DueDate = dat.dueDate;
      this.Status = dat.status;
    },

    async updateClick() {
      try {
        await updateJob(this.JobId, {
          EmployeeName: this.EmployeeName,
          EmployeeDepartment: this.EmployeeDepartment,
          EmployeePosition: this.EmployeePosition, 
          JobContent: this.JobContent,   // ✅ FIXED
          DueDate: this.DueDate,
          Status: this.Status
        });

        document.getElementById("modal-close-btn").click();
        await this.refreshData();
      } catch (e) {
        alert("Update failed " + e);
      }
    },

    async deleteJobClick(id) {
      if (!confirm(ja.ConfirmDelete)) return;

      try {
        await deleteJob(id);
        document.getElementById("modal-closeDetail-btn").click();
        await this.refreshData();
      } catch (e) {
        alert("Delete failed " + e);
      }
    },

    async getTargetEmployeeName(employeeName) {
      this.EmployeeTargetName = employeeName;
      this.employeeJobs = await getEmployeeJobs(employeeName);
    },

    async refreshData() {
      this.jobs = await getTotalJobs();
      this.renderCharts();
    },

    renderCharts() {
      if (!this.jobs || !this.jobs.length) return;

      const labels = this.jobs.map(j => j.employeeName);
      const data = this.jobs.map(j => j.jobCount);

      Chart.register(ChartDataLabels);

      if (this.chartInstancePie) this.chartInstancePie.destroy();
      if (this.chartInstanceBar) this.chartInstanceBar.destroy();

      const generateColors = (count) => {
        const colors = [];
        const baseHue = 210;

        for (let i = 0; i < count; i++) {
          const hueShift = (i * 25) % 360;
          const hue = (baseHue + hueShift) % 360;
          colors.push(`hsla(${hue}, 45%, 70%, 0.85)`);
        }

        return colors;
      };

      const dynamicColors = generateColors(data.length);

      this.chartInstancePie = new Chart(
        document.getElementById("jobPieChart"),
        {
          type: "doughnut",
          data: {
            labels,
            datasets: [{
              data,
              backgroundColor: dynamicColors,
              borderWidth: 2,
              borderColor: "#fff"
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            onClick: (evt, elements) => {
              if (elements.length > 0) {
                const index = elements[0].index;
                const employeeName = labels[index];
                this.getTargetEmployeeName(employeeName);

                const modal = new bootstrap.Modal(
                  document.getElementById("employeeJobModal")
                );
                modal.show();
              }
            },
            plugins: {
              legend: { position: "bottom" }
            }
          }
        }
      );

      this.chartInstanceBar = new Chart(
        document.getElementById("jobBarChart"),
        {
          type: "bar",
          data: {
            labels,
            datasets: [{
              label: "Total Jobs",
              data,
              backgroundColor: dynamicColors,
              borderRadius: 8
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            onClick: (evt, elements) => {
              if (elements.length > 0) {
                const index = elements[0].index;
                const employeeName = labels[index];
                this.getTargetEmployeeName(employeeName);

                const modal = new bootstrap.Modal(
                  document.getElementById("employeeJobModal")
                );
                modal.show();
              }
            },
            scales: {
              y: { beginAtZero: true }
            }
          }
        }
      );
    }
  }
};
</script>

<style scoped>
.modal-header {
  background-color: #cae4ba;
}

.charts-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 30px;
}

.chart-box {
  height: 400px;   /* ADD THIS */
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}
</style>